package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Reference(
    val name: String,
    val enterprise: String,
    val city: String,
    val phone: String,
    val email: String,
)
